import {
  LoginResponse,
  LoginRequest,
  SetBannerRequest,
  BannerImageResponse,
} from "../models";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { authApi } from "../api/auth.api";
import errorModal from "../../../services/errorModal.service";

export const authService = {
  login: async (
    data: LoginRequest
  ): Promise<UnifiedResponse<LoginResponse>> => {
    var response = await authApi.login(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message, false);
    }
    return response;
  },

  signUp: async (data: any): Promise<UnifiedResponse<LoginResponse>> => {
    var response = await authApi.signUp(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message, false);
    }

    return response;
  },

  oneClickSignup: async (data: any,): Promise<UnifiedResponse<LoginResponse>> => {
    var response = await authApi.oneClickSignup(data);

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message, false);
    }
    return response;
  },

  sendOneClickSignupDetails: async (data: any,): Promise<UnifiedResponse<any>> => {
    var response = await authApi.sendOneClickSignupDetails(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message, false);
    }
    return response;
  },

  forgotPassword: async (username: string,notificationData: any,isNotificationSendOnEmail: boolean,): Promise<UnifiedResponse<any>> => {
    return await authApi.forgotPassword(username,notificationData,isNotificationSendOnEmail,);
  },

  verifyForgotPasswordCode: async (
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    var response = await authApi.verifyForgotPasswordCode(code);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  logout: async (): Promise<UnifiedResponse<any>> => {
    return await authApi.logout();
  },

  updatePasswordChangeOneClick: async (): Promise<void> => {
    await authApi.updatePasswordChangeOneClick();
  },

  retrieveBanners: async (
    data: SetBannerRequest
  ): Promise<UnifiedResponse<BannerImageResponse>> => {
    var response = await authApi.retrieveBanners(data);

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }

    return response;
  },
};
